import React from "react";

const SideContent = ({handleTabClick, activeTab} : any) => {

  return (
    <React.Fragment>
      <div className="flex-none w-full md:w-20 xl:w-[200px] dark:bg-darklight dark:border-darkborder overflow-y-auto rounded border border-black/10 p-4 bg-white md:h-[calc(100vh-210px)]">
        <div className="flex flex-wrap gap-2 tabs-list md:flex-col">
          <button
            onClick={() => handleTabClick("compose")}
            className={`bg-purple text-white px-3 py-2.5 flex items-center gap-3 rounded ${
              activeTab === "compose" ? "" : ""
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M16.7574 2.99666L14.7574 4.99666H5V18.9967H19V9.2393L21 7.2393V19.9967C21 20.5489 20.5523 20.9967 20 20.9967H4C3.44772 20.9967 3 20.5489 3 19.9967V3.99666C3 3.44438 3.44772 2.99666 4 2.99666H16.7574ZM20.4853 2.09717L21.8995 3.51138L12.7071 12.7038L11.2954 12.7062L11.2929 11.2896L20.4853 2.09717Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Compose</span>
          </button>
          <button
            onClick={() => handleTabClick("inbox")}
            className={`flex items-center gap-3 px-3 py-2 rounded ${
              activeTab === "inbox"
                ? "text-black dark:text-white bg-light/50 dark:bg-white/5"
                : "text-muted dark:text-darkmuted dark:hover:text-white hover:text-black"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M16.1 3C16.0344 3.32311 16 3.65753 16 4C16 4.34247 16.0344 4.67689 16.1 5H4.51146L12.0619 11.662L17.1098 7.14141C17.5363 7.66888 18.0679 8.10787 18.6728 8.42652L12.0718 14.338L4 7.21594V19H20V8.89998C20.3231 8.96557 20.6575 9 21 9C21.3425 9 21.6769 8.96557 22 8.89998V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3H16.1ZM21 1C22.6569 1 24 2.34315 24 4C24 5.65685 22.6569 7 21 7C19.3431 7 18 5.65685 18 4C18 2.34315 19.3431 1 21 1Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Inbox</span>
          </button>
          <button
            onClick={() => handleTabClick("sent")}
            className={`flex items-center gap-3 px-3 py-2 rounded ${
              activeTab === "sent"
                ? "text-black dark:text-white bg-light/50 dark:bg-white/5"
                : "text-muted dark:text-darkmuted dark:hover:text-white hover:text-black"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M21.7264 2.95706L16.2732 22.0433C16.1222 22.5718 15.7976 22.5958 15.5561 22.1127L10.9998 13.0002L1.92266 9.36931C1.41298 9.16544 1.41929 8.86034 1.9567 8.6812L21.0429 2.31913C21.5714 2.14297 21.8745 2.43878 21.7264 2.95706ZM19.0351 5.0966L6.81197 9.17097L12.4486 11.4256L15.4893 17.507L19.0351 5.0966Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Sent</span>
          </button>
          <button
            onClick={() => handleTabClick("draft")}
            className={`flex items-center gap-3 px-3 py-2 rounded ${
              activeTab === "draft"
                ? "text-black dark:text-white bg-light/50 dark:bg-white/5"
                : "text-muted dark:text-darkmuted dark:hover:text-white hover:text-black"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M20 2C20.5523 2 21 2.44772 21 3V6.757L19 8.757V4H5V20H19V17.242L21 15.242V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20ZM21.7782 8.80761L23.1924 10.2218L15.4142 18L13.9979 17.9979L14 16.5858L21.7782 8.80761ZM13 12V14H8V12H13ZM16 8V10H8V8H16Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Draft</span>
          </button>
          <button
            onClick={() => handleTabClick("spam")}
            className={`flex items-center gap-3 px-3 py-2 rounded ${
              activeTab === "spam"
                ? "text-black dark:text-white bg-light/50 dark:bg-white/5"
                : "text-muted dark:text-darkmuted dark:hover:text-white hover:text-black"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M17.5 2.5L23 12L17.5 21.5H6.5L1 12L6.5 2.5H17.5ZM16.3469 4.5H7.65311L3.311 12L7.65311 19.5H16.3469L20.689 12L16.3469 4.5ZM11 15H13V17H11V15ZM11 7H13V13H11V7Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Spam</span>
          </button>
          <button
            onClick={() => handleTabClick("trash")}
            className={`flex items-center gap-3 px-3 py-2 rounded ${
              activeTab === "trash"
                ? "text-black dark:text-white bg-light/50 dark:bg-white/5"
                : "text-muted dark:text-darkmuted dark:hover:text-white hover:text-black"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M7 4V2H17V4H22V6H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V6H2V4H7ZM6 6V20H18V6H6ZM9 9H11V17H9V9ZM13 9H15V17H13V9Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Trash</span>
          </button>
          <button
            onClick={() => handleTabClick("archive")}
            className={`flex items-center gap-3 px-3 py-2 rounded ${
              activeTab === "archive"
                ? "text-black dark:text-white bg-light/50 dark:bg-white/5"
                : "text-muted dark:text-darkmuted dark:hover:text-white hover:text-black"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              className="w-5 h-5"
            >
              <path
                fill="currentColor"
                d="M20 3L22 7V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V7.00353L4 3H20ZM20 9H4V19H20V9ZM13 10V14H16L12 18L8 14H11V10H13ZM18.7639 5H5.23656L4.23744 7H19.7639L18.7639 5Z"
              ></path>
            </svg>
            <span className="hidden xl:block">Archive</span>
          </button>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SideContent;
